import { Cancel } from "@/assets/icons";
import type { AlfredContextWarningBannerPropsInterface } from "@/interfaces/alfred";
import { Button } from "@/ui/button";

/**
 * AlfredContextWarningBanner - Warning banner shown when context is near limit
 */
export const AlfredContextWarningBanner = ({
    onDismiss,
    percentage,
}: AlfredContextWarningBannerPropsInterface) => (
    <div className="flex items-center gap-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3 text-sm">
        <div className="flex-1 text-yellow-800">
            <span className="font-medium">Context limit warning:</span>
            {" "}
            You&apos;ve used
            {" "}
            {percentage}
            % of the conversation context.
            Consider starting a new conversation for best results.
        </div>
        <Button
            aria-label="Dismiss warning"
            className="size-6 p-0 text-yellow-600 hover:text-yellow-800"
            size="icon"
            variant="ghost"
            onClick={onDismiss}
        >
            <Cancel className="size-4" />
        </Button>
    </div>
);
